import React from 'react'
import PeliLogo from '../assets/PELI_logo_color.png'

const Logo2 = (props) => {
	return <img alt="Logo" src={PeliLogo} style={{ width: 'auto', height: 50 }} {...props} />
}

export default Logo2
